import type { QueueName } from '@/types/common'

/** WebSocket 服务路径（与 API 路由风格统一） */
export const WS_API_PATH = '/api/ws'

/** WebSocket 统一消息信封 */
export interface WSMessage<T = unknown> {
  type: string
  data: T
  meta?: WSMessageMeta
}

export interface WSMessageMeta {
  timestamp: number
  message_id?: string
  job_id?: string
  queue_name?: string
  task_id?: string
}

/** 客户端 → 服务端消息 type */
export enum WSClientMessageType {
  AUTH = 'auth',
  JOB_SUBSCRIBE = 'job.subscribe',
  JOB_UNSUBSCRIBE = 'job.unsubscribe',
  EXPORT_SUBSCRIBE = 'export.subscribe',
  EXPORT_UNSUBSCRIBE = 'export.unsubscribe',
  QUEUE_SUBSCRIBE = 'queue.subscribe',
  QUEUE_UNSUBSCRIBE = 'queue.unsubscribe',
  PONG = 'pong',
}

/** 服务端 → 客户端消息 type */
export enum WSServerMessageType {
  CONNECTED = 'system.connected',
  ERROR = 'system.error',
  PING = 'system.ping',
  JOB_PROGRESS = 'job.progress',
  JOB_COMPLETED = 'job.completed',
  JOB_FAILED = 'job.failed',
  BALANCE_INSUFFICIENT = 'balance.insufficient',
  BALANCE_UPDATED = 'balance.updated',
  EXPORT_PROGRESS = 'export.progress',
}

export interface WSAuthData {
  token: string
}

export interface WSJobSubscribeData {
  job_id: string
  queue_name: QueueName | string
}

export interface WSQueueSubscribeData {
  queue_name: QueueName | string
}

export interface WSExportSubscribeData {
  task_id: string
}

/** job 事件 data（信封层） */
export interface WSJobEventData {
  /** 任务生命周期：progress | completed | failed */
  status: 'progress' | 'completed' | 'failed'
  /** 具体业务 payload，结构见 @/types/job_progress */
  payload?: unknown
}

export interface WSExportProgressData {
  status: 'waiting' | 'running' | 'done' | 'failed'
  progress: number
  project_id?: string
  download_url?: string | null
  error?: string | null
  logs?: string[]
}

export interface WSSystemErrorData {
  code: string
  message?: string
}

/** 余额更新推送 */
export interface WSBalanceUpdatedData {
  balance: number
  amount: number
  usage_type?: string
}

/** 订阅 key 工具 */
export function jobSubscriptionKey(queueName: string, jobId: string): string {
  return `${queueName}:${jobId}`
}

export function exportSubscriptionKey(taskId: string): string {
  return `export:${taskId}`
}

/** Redis Pub/Sub 频道前缀 */
export const WS_REDIS_CHANNEL_PREFIX = 'ws:events:'

export function wsRedisChannel(userId: string): string {
  return `${WS_REDIS_CHANNEL_PREFIX}${userId}`
}
